import { getYoutubeVideoCover } from "@/utils/youtube";
import BlogContent from "../BlogContent";
import { BLOG_TAGS } from "../BlogTags";

const PODCAST_5: BlogContent = {
  id: 17,
  label: "Kodėl sveikatai svarbu ne tyrimų kiekis, o jų logika",
  description:
    "Kodėl vien kraujo tyrimų nepakanka? Ir kada „profilaktika“ virsta chaotišku tikrinimusi be aiškaus plano? Šiame epizode Vaiva Zinkevičiūtė-Balsė, MD, sveikos gyvensenos praktikė ir šeimos gydytoja Aleksandra Liepaitė aptaria, kaip iš tikrųjų atrodo protinga prevencija.",
  descriptionInner:
    "Kodėl vien kraujo tyrimų nepakanka? Ir kada „profilaktika“ virsta chaotišku tikrinimusi be aiškaus plano? Šiame epizode Vaiva Zinkevičiūtė-Balsė, MD, sveikos gyvensenos praktikė ir šeimos gydytoja Aleksandra Liepaitė aptaria, kaip iš tikrųjų atrodo protinga prevencija.",
  img_src: getYoutubeVideoCover("DbcKzwmFVEQ"),
  alt: "Podcast ep.5",
  tags: [
    BLOG_TAGS.PODCASTS.label,
    BLOG_TAGS.BLOOD_TEST.label,
    "Ligų prevencija",
  ],
  author: "Gyvensenos medicinos gydytoja - Vaiva Zinkevičiūtė-Balsė.",
  innerData: [
    {
      id: 1,
      description: [
        "Šiame epizode kalbame apie tai, kaip kraujo tyrimai gali padėti aptikti ligų rizikas dar prieš pasireiškiant simptomams. Aiškiai ir paprastai aptariame insulino rezistenciją, uždegiminius procesus, lipidų disbalansą, hormonų pokyčius ir kaip šie rodikliai atskleidžia kūno būklę ankstyvoje stadijoje.",
        "Taip pat nagrinėjame, kodėl vienas tyrimas be konteksto gali klaidinti, kaip sveikatos specialistai analizuoja rodiklių sąveikas ir kada dirbtinis intelektas yra pagalba, o kada – rizika. Epizodo pabaigoje – praktinės rekomendacijos, kaip dažnai tirtis ir nuo ko pradėti.",
        "Laidos vedėjas: Gyvensenos medicinos gydytoja - Vaiva Zinkevičiūtė-Balsė.",
      ],
    },
  ],
  podcasts: {
    youtube: "DbcKzwmFVEQ",
    spotify: "0XNcLSFh0KYj4Q4XUDbKa5?si=92f8e9b4cc704554",
    apple: "1000735525492",
  },
};

export default PODCAST_5;
